export const SKIPTRACE_RATE_LIMIT_NOTE = 'Skiptracing is subject to rate limits and as such is not available in bulk lists.'

export const BULK_SKIPTRACE_RATE_LIMIT_NOTE = 'Bulk Skiptracing is not subject to skiptracing rate limits.'

export const SHARED_SKIPTRACE_BUCKET_NOTE = 'For this plan, Skiptrace and Bulk Skiptrace share the same free/paid skiptrace bucket.'
